import i18n from "i18n";

export const ParseMovement = {

    getMovementType: (movement_tipe) => {
        switch (movement_tipe) {
            case "IN":
                return i18n.t("movement.type.IN");
            case "OUT":
                return i18n.t("movement.type.OUT");
            case "MOVE":
                return i18n.t("movement.type.MOVE");
            default:
                return '';

        }
    },

    getOrderType: (order_type) => {

        switch (order_type) {
            case "REL":
                return i18n.t("orders.types.REL");
                return i18n.t("orders.types.REL");
            case "PUR":
                return i18n.t("orders.types.PUR");
            case "REQ":
                return i18n.t("orders.types.REQ");
            case "SAL":
                return i18n.t("orders.types.SALE");
            case "PRE":
                return i18n.t("orders.types.PRE");
            case "REC":
                return i18n.t("orders.types.REC");
            default:
                return '';
                break;
        }
    },

    getOrderKlass: (order_klass) => {

        switch (order_klass) {
            case "BAS":
                return i18n.t("orders.klasses.BAS");
                return i18n.t("orders.klasses.BAS");
            case "REQ":
                return i18n.t("orders.klasses.REQ");
                return i18n.t("orders.klasses.REQ");
            case "ADJ":
                return i18n.t("orders.klasses.ADJ");
                return i18n.t("orders.klasses.ADJ");
            case "SALE":
                return i18n.t("orders.klasses.SALE");
            case "PUR":
                return i18n.t("orders.klasses.PUR");
                return i18n.t("orders.klasses.PUR");
            case "REF":
                return i18n.t("orders.klasses.REF");
                return i18n.t("orders.klasses.REF");
            case "PRO":
                return i18n.t("orders.klasses.PRO");
                return i18n.t("orders.klasses.PRO");
            case "BRE":
                return i18n.t("orders.klasses.BRE");
            case "LOSS":
                return i18n.t("orders.klasses.LOSS");
            case "AUD":
                return i18n.t("orders.klasses.AUD");
            default:
                return '';
                break;
        }
    }
}
